var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"outside-fixedcode"},[_c('div',{directives:[{name:"show",rawName:"v-show",value:(_vm.noOrder),expression:"noOrder"}],staticClass:"no-car"},[_c('img',{attrs:{"src":require("@/assets/image/chahua.png"),"alt":""}}),_c('span',[_vm._v(_vm._s(_vm.noOrderText))])])])
}
var staticRenderFns = []

export { render, staticRenderFns }